import React, { useState } from "react";
import { rgba, tint, shade } from "polished";
import styled from "styled-components";
import * as Clrs from "../../src/js/colors";
import { Painting, Year } from "../components/painting";
import { Modal, CloseModal } from "../components/modal";

import p1 from "../images/anUnmarkedPlace.jpg";
import p2 from "../images/thisTooShallPass.jpg";
import p3 from "../images/weatherWorry.jpg";
import p4 from "../images/theRoadToNowhere.jpg";
import p5 from "../images/height.jpg";
import p6 from "../images/coldQuietDark.jpg";
import p7 from "../images/beforeFalling.jpg";
import p8 from "../images/contractOfLand.jpg";
import p9 from "../images/theyFlutterBehindYou.jpg";
import p10 from "../images/pivots.jpg";
import p11 from "../images/rocks.jpg";
import p12 from "../images/alteredLandscape.jpg";
import p13 from "../images/falling.jpg";
import p14 from "../images/grove.jpg";
import p15 from "../images/masTequila.jpg";
import p16 from "../images/sunflower.jpg";
import p17 from "../images/sunflowers2.jpg";
import p18 from "../images/itsSuchADrag.jpg";
import p19 from "../images/nowayout.jpg";
import p20 from "../images/oldhead.jpg";
import p21 from "../images/theGreenJacket.jpg";
import p22 from "../images/fjordOfSorts.jpg";
import p23 from "../images/Somewhere-Up-North.jpg";
import p24 from "../images/untitled2.jpg";
import p25 from "../images/theIowa.jpg";
import p26 from "../images/natureswall.jpg";
import p27 from "../images/natureswall2.jpg";
import p28 from "../images/abbeysomething.jpg";
import p29 from "../images/couldyoubemine.jpg";
import p30 from "../images/self2.jpg";
import p31 from "../images/crofts.jpg";
import p32 from "../images/takeawalk.jpg";
import p33 from "../images/natureswall3.jpg";
import p34 from "../images/winterscene.jpg";
import p35 from "../images/tiger.jpg";
import p36 from "../images/newLife1.jpg";
import p37 from "../images/newLife2.jpg";
import p38 from "../images/newLife3.jpg";

import { Grid12, Grid12Area } from "../components/grid12";
import { FluidGrid } from "../components/fluidgrid";

const DemoGrid = styled.div`
  display: flex;
  width: 100%;
  min-height: 40px;
  box-sizing: border-box;
  flex: 1 1 auto;
  color: white;
  align-items: ${(props) => props.align};
  justify-content: ${(props) => props.justify};
`;

function Paintings(props) {
  const [showModal, setShowModal] = useState(null);
  const [selectedImg, setSelectedImg] = useState(null);
  const [descriptionText, setDescriptionText] = useState("");
  function closeModal() {
    setShowModal(false);
  }
  function openModal(img) {
    setShowModal(true);
    setSelectedImg(img);
  }
  const P = styled.p`
    color: ${Clrs.white};
    font: Arial, sans-serif;
    line-height: 18px;
    font-size: 11px;
    margin: 20px 10px;
  `;
  return (
    <>
      <Grid12 gap="medium">
        <Grid12Area colssm="1/7">
          <P>
            These are the personal artworks of J. Price. A heavy dose of
            landscape - mostly imagined - and often an exploration into how
            humanity alters it.
          </P>
        </Grid12Area>
      </Grid12>
      <FluidGrid gap="wide">
        <DemoGrid>
          <Painting
            txt="New Life #3"
            bgimg={p38}
            label="2025 ->"
            labelposition="left"
            labelcolor={Clrs.light}
            onClick={() => {
              openModal(p38);
              setDescriptionText('New Life #3 || Oil on canvas || 48" x 46"');
            }}
            closeFunc={() => setShowModal(false)}
          >
            {/* <img alt="txt" src={p30} /> */}
          </Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="New Life #2"
            bgimg={p37}
            labelposition="left"
            labelcolor={Clrs.light}
            onClick={() => {
              openModal(p37);
              setDescriptionText("New Life #2 || Oil on canvas || dimensions");
            }}
            closeFunc={() => setShowModal(false)}
          >
            {/* <img alt="txt" src={p30} /> */}
          </Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="New Life #1"
            bgimg={p36}
            flag="sold"
            labelposition="left"
            labelcolor={Clrs.light}
            onClick={() => {
              openModal(p36);
              setDescriptionText("New Life #1 || Oil on canvas || dimensions");
            }}
            closeFunc={() => setShowModal(false)}
          >
            {/* <img alt="txt" src={p30} /> */}
          </Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Untitled"
            bgimg={p30}
            label="2023 ->"
            labelposition="left"
            labelcolor={Clrs.light}
            onClick={() => {
              openModal(p30);
              setDescriptionText(
                "Untitled || Oil on canvas board || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          >
            {/* <img alt="txt" src={p30} /> */}
          </Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="The Crofts"
            bgimg={p31}
            onClick={() => {
              openModal(p31);
              setDescriptionText(
                "The Crofts || Oil on canvas board || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          >
            {/* <img alt="txt" src={p31} /> */}
          </Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Nature's Wall 3"
            bgimg={p33}
            flag="sold"
            label="2022 ->"
            labelposition="left"
            labelcolor={Clrs.light}
            onClick={() => {
              openModal(p33);
              setDescriptionText(
                "Nature's Wall 3 || Oil on canvas board || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="We Take a Walk..."
            bgimg={p32}
            onClick={() => {
              openModal(p32);
              setDescriptionText(
                "We Take a Walk... || Oil on canvas board || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Could You Be Mine?"
            bgimg={p29}
            onClick={() => {
              openModal(p29);
              setDescriptionText(
                `Could You Be Mine? || Oil on canvas board || 60" x 28" `
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Untitled"
            bgimg={p34}
            onClick={() => {
              openModal(p34);
              setDescriptionText(
                "Untitled || Oil on canvas board || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="The Iowa"
            flag="sold"
            label="2021 ->"
            labelposition="left"
            labelcolor={Clrs.light}
            bgimg={p25}
            onClick={() => {
              openModal(p25);
              setDescriptionText(
                "The Iowa || Oil on canvas board || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Nature's Wall #1"
            flag="sold"
            bgimg={p26}
            onClick={() => {
              openModal(p26);
              setDescriptionText(
                `Nature's Wall #1 || Oil on canvas board || 36" x 18" `
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Nature's Wall #2"
            flag="sold"
            bgimg={p27}
            onClick={() => {
              openModal(p27);
              setDescriptionText(
                `Nature's Wall #2 || Oil on canvas board || 36" x 12" `
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Sentinel"
            bgimg={p16}
            label="2019 ->"
            labelposition="left"
            labelcolor={Clrs.light}
            onClick={() => {
              openModal(p16);
              setDescriptionText(
                "Sentinel || Oil on canvas board || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="A Solemn Gathering"
            bgimg={p17}
            flag="sold"
            onClick={() => {
              openModal(p17);
              setDescriptionText(
                "A Solemn Gathering || Oil on panel || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="18 at Oldhead"
            flag="sold"
            bgimg={p20}
            onClick={() => {
              openModal(p20);
              setDescriptionText(
                "18 at Oldhead || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        {/*  <DemoGrid>
          <Painting
            txt="The Green Jacket"
            bgimg={p21}
            onClick={() => {
              openModal(p21);
              setDescriptionText(
                "The Green Jacket || Oil on canvas board || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid> */}
        <DemoGrid>
          <Painting
            txt="This Too Shall Pass"
            bgimg={p2}
            label="2018 ->"
            labelposition="left"
            labelcolor={Clrs.light}
            onClick={() => {
              openModal(p2);
              setDescriptionText(
                "This Too Shall Pass || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Untitled"
            bgimg={p35}
            onClick={() => {
              openModal(p35);
              setDescriptionText("Untitled || Oil on canvas || dimensions");
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="They Flutter Behind You"
            bgimg={p9}
            onClick={() => {
              openModal(p9);
              setDescriptionText(
                "They Flutter Behind You || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          {" "}
          <Painting
            txt="Somewhere Up North"
            bgimg={p23}
            onClick={() => {
              openModal(p23);
              setDescriptionText(
                "Somewhere Up North || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="An Unmarked Place"
            flag="sold"
            label="2017 ->"
            labelposition="left"
            labelcolor={Clrs.light}
            bgimg={p1}
            onClick={() => {
              openModal(p1);
              setDescriptionText(
                "An Unmarked Place || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Weather; Worry"
            flag="sold"
            bgimg={p3}
            onClick={() => {
              openModal(p3);
              setDescriptionText(
                "Weather; Worry || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="The Road to Nowhere"
            bgimg={p4}
            flag="private collection"
            onClick={() => {
              openModal(p4);
              setDescriptionText(
                "The Road to Nowhere || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="It's Such a Drag"
            bgimg={p18}
            onClick={() => {
              openModal(p18);
              setDescriptionText(
                "It's Such a Drag || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          {" "}
          <Painting
            txt="Untitled"
            bgimg={p24}
            onClick={() => {
              openModal(p24);
              setDescriptionText("Untitled || Oil on canvas || dimensions");
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="There's No Way Out of Here"
            bgimg={p19}
            onClick={() => {
              openModal(p19);
              setDescriptionText(
                "There's No Way Out of Here || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Height"
            bgimg={p5}
            label="2016 ->"
            labelposition="left"
            labelcolor={Clrs.light}
            onClick={() => {
              openModal(p5);
              setDescriptionText("Height || Oil on canvas || dimensions");
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Cold, Quiet & Dark"
            bgimg={p6}
            onClick={() => {
              openModal(p6);
              setDescriptionText(
                "Cold, Quiet & Dark || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Before Falling"
            bgimg={p7}
            onClick={() => {
              openModal(p7);
              setDescriptionText(
                "Before Falling || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="A Contract of Land"
            bgimg={p8}
            flag="sold"
            onClick={() => {
              openModal(p8);
              setDescriptionText(
                "A Contract of Land || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Pivots"
            flag="sold"
            bgimg={p10}
            onClick={() => {
              openModal(p10);
              setDescriptionText("Pivots || Oil on canvas || dimensions");
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="The Rocks Slowed Our Descent"
            bgimg={p11}
            onClick={() => {
              openModal(p11);
              setDescriptionText(
                "The Rocks Slowed Our Descent || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Altered Landscape"
            bgimg={p12}
            flag="sold"
            onClick={() => {
              openModal(p12);
              setDescriptionText(
                "Altered Landscape || Oil on canvas || dimensions"
              );
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Falling"
            bgimg={p13}
            label="2015 ->"
            labelposition="left"
            labelcolor={Clrs.light}
            flag="sold"
            onClick={() => {
              openModal(p13);
              setDescriptionText("Falling || Oil on canvas || dimensions");
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Grove"
            bgimg={p14}
            onClick={() => {
              openModal(p14);
              setDescriptionText("Grove || Oil on canvas || dimensions");
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
        <DemoGrid>
          <Painting
            txt="Mas Tequila"
            bgimg={p15}
            flag="sold"
            onClick={() => {
              openModal(p15);
              setDescriptionText(`Mas Tequila || Oil on canvas || 36" x 36"`);
            }}
            closeFunc={() => setShowModal(false)}
          ></Painting>
        </DemoGrid>
      </FluidGrid>

      <Modal
        in={showModal}
        desc={descriptionText}
        closeFunc={() => setShowModal(false)}
        closebtn={
          <CloseModal onClick={() => setShowModal(false)}>Close</CloseModal>
        }
      >
        <img src={selectedImg} />
      </Modal>
    </>
  );
}

export { Paintings };
